<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Gadai</h5>
            </template>
            <DetailGadaiKomp :detailGadai="dataDetailGadai" />
            <div class="detail-edit-btn btn-footer-detail-gadai" >
                <b-button variant="pgiBtn" name="gadaiEditBtn" v-if="dataDetailGadai.statusGadai == 'Berjalan' && allowedEdit == 1" @click="editGadai">Edit</b-button>
                <b-button variant="pgiBtn" name="printBarcode" v-if="allowedPrintBarcode == 1" @click="printBarcode">Print Ulang Barcode</b-button>
                <b-button variant="cancelBtn" name="ajukanHilang" v-if="allowedHilang == 1" @click="openAjukanHilang">Ajukan Penghapusan Barang</b-button>
                <b-button variant="cancelBtn" name="setTarik" v-if="setTarik == 1" @click="openSetTarik">Set Tarik</b-button>
            </div>
        </b-card>

        <b-modal id="modal-ajukan-hilang" title="Ajukan Penghapusan Barang" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="ajukanNotaHilang" @submit.prevent="onSubmitAjukan">
                <DataFotoGadai :dataFotoPendukung="input.dataFotoPendukung" />
                <div class="form-content-wrapper mt-4 mb-0">
                    <b-form-group label="Keterangan" class="mb-0">
                        <b-form-textarea
                        v-model="input.keteranganNotaHilang"
                        name="keteranganNotaHilang"
                        rows="3"
                        required
                        ></b-form-textarea>
                    </b-form-group>
                    <b-form-group label="Polsek" class="mt-4">                     
                        <b-form-input v-model="input.polsek"  name="polsek"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Perihal" class="mt-4">       
                        <multiselect v-model="input.perihalId" :options="perihalOpt" :internal-search="true"
                        :allow-empty="false" deselect-label="" select-label="" label="name" track-by="id"
                        placeholder="-- Please select an option --" />
                    </b-form-group>
                    <b-form-group label="Tanggal Kejadian" class="mt-4">
                        <b-form-input type="date" v-model="input.tanggalKejadian"  name="tglKejadian"></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelAjukanNotaBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeAjukanNotaBtn" :disabled="isSubmitting" type="submit" form="ajukanNotaHilang">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Ajukan Penghapusan Barang'}}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-set-tarik" title="Set Tarik Gadai" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="setTarikForm" @submit.prevent="onSetTarik">
                <DataFotoGadai :dataFotoPendukung="input.dataFotoPendukung" />
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelSetTarikBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeSetTarikBtn" :disabled="isSubmitting" type="submit" form="setTarikForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Set Tarik Gadai'}}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="m-print-barcode" title="Print Ulang Barcode" size="xl" ok-only centered no-close-on-backdrop no-close-on-esc>
            <p class="smallText text-muted">
                Bila tombol print / cetak tidak ditemukan, anda dapat melakukan pencetakan dengan cara klik kanan pada lembar yang akan dicetak, lalu pilih Print.
            </p>
            <b-row>
                <b-col><iframe width="100%" height="300" :src="barcodePath" frameborder="0" allowfullscreen></iframe></b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>

import DetailGadaiKomp from '../../components/gadai/DetailGadaiKomp';
import DataFotoGadai from '../../components/baranghilang/DataFotoGadai';

export default {
    name: 'detail-gadai',
    components: {
        DetailGadaiKomp,
        DataFotoGadai
    },
    data() {
        return {

            id: null,
            initStatus: 0,
            isSubmitting: false,
            isFetching: false,

            dataDetailGadai: [],
            statusGadai: null,

            allowedEdit: 0,
            allowedHilang: 0,
            allowedPrintBarcode: 0,
            setTarik: 0,

            barcodePath: "",

            input: {
                keteranganNotaHilang: "",
                polsek: null,
                perihalId: null,
                tanggalKejadian: null,
                dataFotoPendukung: {
                    fotoPendukung: null,
                    fotoPendukungBase64: null,
                    activeFotoPendukungBase64: null,
                } 
            },

            perihalOpt : []

        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleGadai = this.$axios.get(`gadai/detail/id/${this.id}`).then(response => {
                this.dataDetailGadai = response.data
            })

            let getStatusGadai = this.$axios.get(`gadai/daftar-gadai/${this.id}/status`).then(response => {
                this.statusGadai = response.data.id
            })

            let getAllowedEdit = this.$axios.get("gadai/edit-allowed").then(response => {
                this.allowedEdit = response.data.id
            })

            let getAllowedHilang = this.$axios.get("gadai/barang-hilang-allowed").then(response => {
                this.allowedHilang = response.data.id
            })

            let getAllowedPrintBarcode = this.$axios.get("gadai/print-barcode-allowed").then(response => {
                this.allowedPrintBarcode = response.data.id
            })

            let getSetTarik = this.$axios.get(`daftar-penarikan/tarik-allowed/?gadaiId=${this.id}`).then(response => {
                this.setTarik = response.data.id
            })

            let getOptionPerihal = this.$axios.get(`/perihal/?type=1&isActive=true`).then(response => {
                this.perihalOpt = response.data
            })

            Promise.all([getSingleGadai, getStatusGadai,getAllowedEdit, getAllowedHilang, getSetTarik, getAllowedPrintBarcode, getOptionPerihal]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        editGadai(){
            
            if ( this.dataDetailGadai.barang.jenisPinjaman.id == 1 ) {
                if ( this.statusGadai != 0 ) {
					this.$router.push({path: `${this.$route.path}/elek-staging`});
				}else{
					this.$router.push({path: `${this.$route.path}/elektronik`});
				}
            }

            if ( this.dataDetailGadai.barang.jenisPinjaman.id == 2 ) {
                if ( this.statusGadai != 0 ) { 
                    this.$router.push({path: `${this.$route.path}/kend-staging`});
                }else{
                    this.$router.push({path: `${this.$route.path}/kendaraan`});
                }
            }

            if ( this.dataDetailGadai.barang.jenisPinjaman.id == 3 ) {
                if ( this.statusGadai != 0 ) {
					this.$router.push({path: `${this.$route.path}/emas-staging`});
				}else{
					this.$router.push({path: `${this.$route.path}/emas`});
				}
            }
        },

        openAjukanHilang(){
            if (this.input.dataFotoPendukung.activeFotoPendukungBase64 != null) {
                this.input.dataFotoPendukung.activeFotoPendukungBase64 = []
            }
            this.$bvModal.show("modal-ajukan-hilang")
        },

        onSubmitAjukan(){
            if (!this.hasFotoPendukung()) {
                this.$helper.toastErr(this, "Tolong upload foto terlebih dahulu!")
                return
            } 
            if (this.input.polsek == null) {
                this.$helper.toastErr(this, "Tolong isi polsek terlebih dahulu!")
                return
            } 
            if (this.input.keteranganNotaHilang == null) {
                this.$helper.toastErr(this, "Tolong isi Keterangan terlebih dahulu!")
                return
            } 
            if (this.input.perihalId == null) {
                this.$helper.toastErr(this, "Tolong pilih perihal terlebih dahulu!")
                return
            } 
            if (this.input.tanggalKejadian == null) {
                this.$helper.toastErr(this, "Tolong isi Tanggal Kejadian terlebih dahulu!")
                return
            } 
          
                // let jsonFoto = []
                // let payload = new FormData()

                // payload.append("gadaiId", this.id)
                // payload.append("keterangan", this.input.keteranganNotaHilang)
               
                // for(var item of this.input.dataFotoPendukung.activeFotoPendukungBase64){
                //     jsonFoto.push(item)
                // }
                // payload.append("foto", JSON.stringify(jsonFoto))
                // payload.append("gadaiId", this.id)
                // payload.append("keterangan", this.input.keteranganNotaHilang)
               
                let jsonFoto = []
                let payload = {
                    gadaiId: this.id,
                    keterangan: this.input.keteranganNotaHilang,
                    polsek: this.input.polsek,
                    perihalId: this.input.perihalId.id,
                    tanggalKejadian: this.input.tanggalKejadian,
                    foto: null
                }

           
                for(var item of this.input.dataFotoPendukung.activeFotoPendukungBase64){
                    jsonFoto.push(item)
                }
                // payload.append("foto", JSON.stringify(jsonFoto))
                payload.foto = JSON.stringify(jsonFoto)
                //----------------- Submit Semua Data -----------------

                this.isSubmitting = true

                this.$axios.post("gadai-hilang/pengajuan/", payload).then(() => {
                    this.$helper.setFlash("Pengajuan nota hilang berhasil dilakukan")
                    let path = this.$route.path.split("/")
                    path.pop()
                    path = path.join("/")
                    this.$router.push({ path })
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },

        openSetTarik(){
            this.$bvModal.show("modal-set-tarik")
        },

        onSetTarik(){
            if (!this.hasFotoPendukung()) {
                this.$helper.toastErr(this, "Tolong upload foto terlebih dahulu!")
                return
            } 
            let payload = new FormData()

            //----------------- Append Data Promo -----------------

            payload.append("gadaiId", this.id)
            payload.append('foto', this.input.dataFotoPendukung.activeFotoPendukungBase64)
            
            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("daftar-penarikan/set-tarik/", payload).then(() => {
                this.$helper.setFlash("Gadai berhasil ditarik!")
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        hasFotoPendukung() {
            const activeFoto = this.input.dataFotoPendukung.activeFotoPendukungBase64
            return Array.isArray(activeFoto) ? activeFoto.length > 0 : this.$helper.isNotNullAndNotEmpty(activeFoto)
        },

        printBarcode() {

            this.$bvModal.show("m-print-barcode")
            this.isFetching = true

            this.$axios.get(`gadai/print-barcode/${this.$route.params.id}`).then(res => {
                this.barcodePath = this.$baseFilePath + res.data.name
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isFetching = false)

        }

    },

    created() {
        this.init()
    }
}
</script>

<style>
.btn-footer-detail-gadai {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}
</style>
